import { useEffect } from 'react';
import { useWeb3React } from '@web3-react/core';

import { injectedConnector } from './useWeb3Connection';

function useMetaMaskChangeListener(): void {
    const { active, error, activate } = useWeb3React();

    useEffect(() => {
        const { ethereum } = window;
        if (ethereum && ethereum.on && !active && !error) {
            const handleChainChanged = (): void => {
                activate(injectedConnector, undefined, false);
            };

            ethereum.on('chainChanged', handleChainChanged);

            return () => {
                if (ethereum.removeListener) {
                    ethereum.removeListener('chainChanged', handleChainChanged);
                }
            };
        }
        return () => {};
    }, [active, error, activate]);
}

export { useMetaMaskChangeListener };
